// src/contexts/geral/PrinterContext.js
import { formatarVariacoes } from '../../utils/VariacaoUtils';
import React, { createContext, useContext, useCallback, useState, useEffect, useRef } from 'react';
import { useMessage } from '../../contexts/geral/MessageContext';
import { formatCurrency, formatNumeric } from '../../utils/numberUtils';
import { getNumeroPedido } from '../../utils/pedidoUtils';
import { formatTelefone } from '../../utils/telefoneUtils';
import { useConfigModulo } from '../administrativo/ConfigModuloContext';
import { getComprovantePagComandaPDF, solicitarComprovantePagComandaMonitor } from '../../services/controleBar/ComprovantePagComandaService';
import { selecionarComandasQuitadas } from '../../models/controleBar/comandas/ComprovantePagComanda';
import { useNota } from '../vendas/NotaContext';
import { useFilial } from '../administrativo/FilialContext';
import { useConjunto } from '../produtos/combos/ConjuntoContext';
import { FaMotorcycle } from "react-icons/fa6";
import { FaMapMarkerAlt, FaPhoneAlt, FaReceipt, FaRegStickyNote, FaUser, FaClock, FaShoppingBag, FaUtensils } from "react-icons/fa";
import { renderToStaticMarkup } from 'react-dom/server';
import { MdOutlineTableBar } from 'react-icons/md';
import { getPedidoPDFByIdService } from '../../services/pedidos/PedidoService';
import { getDanfeNFCePDFByNotaIdService, getDanfsePDFByNotaIdService, getReciboPDFByNotaIdService } from '../../services/vendas/PDVService';
//import { useConfigWhats } from '../pedidos/ConfigWhatsContext';

// Criar o contexto
const PrinterContext = createContext();

export const PrinterProvider = ({ children }) => {
    const { showMessage } = useMessage();
    const { configModuloSel } = useConfigModulo();
    const [isConfigLoaded, setIsConfigLoaded] = useState(false);
    const filaImpressaoFiscalRef = useRef(Promise.resolve());
    const comprovantesPendentesRef = useRef(new Map());
    const [quantidadeComprovantesPendentes, setQuantidadeComprovantesPendentes] = useState(0);
    const [reimprimindoComprovantes, setReimprimindoComprovantes] = useState(false);
    const { filialLogin, logoFilialLogin, fetchFiliais, fetchFilialLogo } = useFilial();
    const { fetchConjuntoById } = useConjunto();
    //const { configWhats } = useConfigWhats();

    const {buscaNotaById} = useNota();

    const parseNumero = (valor) => {
        if (valor === null || valor === undefined || valor === '') return 0;
        if (typeof valor === 'string') {
            const normalizado = valor.includes(',')
                ? valor.replace(/\./g, '').replace(',', '.')
                : valor;
            const numero = Number(normalizado);
            return Number.isNaN(numero) ? 0 : numero;
        }
        const numero = Number(valor);
        return Number.isNaN(numero) ? 0 : numero;
    };

    const escapaHtml = (texto) => String(texto)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const isComprovanteMSitef = (comprovante) => (
        String(comprovante).includes('"VIA CLIENTE"')
    );

    const formataComprovanteTEF = (comprovante) => {
        let partes = comprovante;

        if (typeof comprovante === 'string') {
            try {
                partes = JSON.parse(comprovante);
            } catch {
                partes = [comprovante.replace(/\\r\\n|\\n|\\r/g, '\n')];
            }
        }

        if (!Array.isArray(partes)) partes = [partes];

        const indiceViaCliente = partes.findIndex(parte => (
            String(parte).trim().toUpperCase() === 'VIA CLIENTE'
        ));

        if (indiceViaCliente >= 0) {
            // Imprime somente o título e o conteúdo da via do cliente.
            partes = partes.slice(indiceViaCliente, indiceViaCliente + 2);
        }

        return partes
            .filter(parte => parte !== null && parte !== undefined && parte !== '')
            .map(parte => escapaHtml(String(parte).replace(/\r\n|\r/g, '\n')))
            .join('\n');
    };

    const isValorVerdadeiro = (valor) => (
        valor === true ||
        valor === 1 ||
        valor === '1' ||
        String(valor).toLowerCase() === 'true'
    );

    const formatQtdConjunto = (qtd) => {
        if (Number.isInteger(qtd)) return qtd.toString();
        return formatNumeric(qtd, 2).replace(/,?0+$/, '');
    };

    const getQtdConjuntoImpressao = (itemConjunto, conjuntoReferencia = null, totalItensSelecionados = 0) => {
        const conjunto = conjuntoReferencia || itemConjunto?.conjunto || itemConjunto?.Conjunto || {};
        const usaFracao = isValorVerdadeiro(
            conjunto?.UsarFracao ??
            conjunto?.usarFracao ??
            conjunto?.usaFracao ??
            itemConjunto?.UsarFracao ??
            itemConjunto?.usarFracao ??
            itemConjunto?.usaFracao
        );
        const qtd = parseNumero(itemConjunto?.qtdItens ?? itemConjunto?.QtdItens ?? 1);
        const qtdTotalSelecionada = parseNumero(totalItensSelecionados);

        if (usaFracao && qtdTotalSelecionada > 0) {
            return `${formatQtdConjunto(qtd)}/${formatQtdConjunto(qtdTotalSelecionada)}`;
        }

        return `${formatQtdConjunto(qtd)}x`;
    };

    useEffect(() => {
        if (configModuloSel) {
            setIsConfigLoaded(true);
        }
    }, [configModuloSel]);

    const gerarTicketProduto = (item, nota, numTicket) => {
        const descricao = item?.xProd?.toUpperCase() || '';
        const observacao = item?.observacao || '';
        const valorUnit = item?.vUnCom?.toFixed(2).replace(".", ",") || '0,00';
        //const codigoBarra = `${nota.id.toString().padStart(6, '0')}${item.id.toString().padStart(6, '0')}`;
        // Geração do código de barras com valor pseudoaleatório
        console.log('Num Ticket: '+numTicket);
        const valorAleatorio = Math.floor(Math.random() * 100);
        const codigoBarra = `${nota.id.toString().padStart(6, '0')}${numTicket.toString().padStart(4, '0')}${valorAleatorio.toString().padStart(2, '0')}`;
        const dataHora = new Date(nota.dataLanc).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });

        return `
            <html>
            <head>
                <title>Ticket</title>
                <style>
                    @page { size: auto; margin: 0; }
                    body { font-family: monospace; font-size: 14px; margin: 0; padding: 10px; width: 72mm; text-align: center; }
                    h2 { margin: 5px 0; }
                    hr { border: 1px dashed #000; }
                    p { margin: 5px 0; }
                    svg { margin-top: 5px; }
                </style>
                <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js" defer></script>
            </head>
            <body>
                <hr />
                <h2>TICKET DE ALIMENTAÇÃO</h2>
                <hr />
                <p><strong>Item:</strong> ${descricao}</p>
                <p><strong>Valor:</strong> R$ ${valorUnit}</p>
                ${observacao ? `<p><strong>Obs:</strong> ${observacao}</p>` : ""}

                <svg id="barcode"></svg>

                <hr />
                <p>NOROESTE SUMMIT<br>${dataHora}</p>
                <hr />

                <script>
                    document.addEventListener("DOMContentLoaded", function () {
                        if (typeof JsBarcode === 'function') {
                            JsBarcode("#barcode", "${codigoBarra}", {
                                format: "CODE128",
                                displayValue: true,
                                fontSize: 14,
                                height: 40,
                                width: 2
                            });
                        } else {
                            console.error("JsBarcode não carregado.");
                        }
                    });
                </script>
            </body>
            </html>
        `;
    };

    // Função para gerar o recibo de impressão usando HTML (baseado em geraViaNFCe e gerarResumoCaixa)
    const  gerarRecibo = async (notaId) => {

        const nota = await buscaNotaById(notaId);

        if (!nota.notaItens?.length) {
            showMessage("Nenhum item na venda para imprimir.", "warning");
            return "";
        }

        let recibo = `
        <html>
        <head>
            <title>Impressão de Recibo</title>
            <style>
                @page { size: auto; margin: 0; }
                body { font-family: monospace; font-size: 12px; margin: 0; padding: 10px; width: 72mm; }
                h2, h3 { text-align: center; margin: 2px 0; }
                hr { border: 1px dashed #000; }
                p { margin: 2px 0; }
                .item-row { display: flex; justify-content: space-between; }
                .item-table { width: 100%; border-collapse: collapse; }
                .item-table th, .item-table td { padding: 2px; text-align: left; font-size: 12px; }
                .item-table th { font-weight: bold; }
                .total-row { display: flex; justify-content: space-between; }
                strong { font-weight: bold; }
            </style>
        </head>
        <body>`;

        // Início do recibo
        
        
        recibo += `<h1>${nota.filial.empresa.nome}</h1>`;
        recibo += "<hr>";
        recibo += `<h2>RECIBO DE VENDA</h2>`;
        recibo += "<hr>";

        // Informações do caixa
        recibo += `<p><strong>Caixa:</strong> ${nota.caixa?.descricao || "N/A"}</p>`;
        // recibo += `<p><strong>Operador:</strong> ${nota.operador?.nome || "N/A"}</p>`; // Descomente se tiver operador
        recibo += "<hr>";

        // === NOVO: Cliente + CPF/CNPJ ===
        if (nota.clienteNome && nota.clienteNome !== "CONSUMIDOR FINAL") {
            recibo += `<p><strong>Cliente:</strong> ${nota.clienteNome}</p>`;
        }

        const cpfCnpj = 
            nota.cpf ||
            nota.cnpj;

        if (cpfCnpj) {
            recibo += `<p><strong>CPF/CNPJ:</strong> ${cpfCnpj}</p>`;
            recibo += "<hr>";
        }

        

        // Observação da nota (se houver)
        if (nota.observacao && nota.observacao.trim() !== "") {
            recibo += `
                <p><strong>Observação:</strong></p>
                <p>${nota.observacao.toUpperCase()}</p>
                <hr>
            `;
        }

        // Itens da venda
        recibo += `<h3>Itens</h3>`;
        if (configModuloSel.printValUnRec) {
            //console.log('configModuloList:', configModuloList); // Debug
            
            // Cabeçalho com valor unitário
            recibo += `
                <table class="item-table">
                        <tr>
                            <th style="width: 5%;">SEQ</th>
                            <th style="width: 50%;">DESCRICAO</th>
                            <th style="width: 10%; text-align: right;">QTDE</th>
                            <th style="width: 5%; text-align: center;">UN</th>
                            <th style="width: 10%; text-align: right;">UNIT</th>
                            <th style="width: 15%; text-align: right;">TOTAL</th>
                        </tr>`;
            
            nota.notaItens.forEach(item => {
                const descricaoTruncada = item?.xProd?.substring(0, 19).toUpperCase() || ''; // Limita a 19 caracteres
                recibo += `
                    <tr>
                        <td>${String(item?.item).padStart(3, '0')}</td>
                        <td>${descricaoTruncada}</td>
                        <td style="text-align: right;">${formatNumeric(item?.qtdCom)}</td>
                        <td style="text-align: center;">${item?.unCom}</td>
                        <td style="text-align: right;">${item?.vUnCom.toFixed(2).replace(".", ",")}</td>
                        <td style="text-align: right;">${item?.vProd.toFixed(2).replace(".", ",")}</td>
                    </tr>`;
            });

            recibo += `</table>`

        } else {            
            nota.notaItens.forEach(item => {                
                const descricao = `${item.qtdCom}x ${item?.xProd.toUpperCase()}`;
                const descricaoTruncada = descricao.substring(0, 32) || ''; // Limita a 32 caracteres                
                recibo += `<p class="item-row">
                    <span>${descricaoTruncada}</span>
                    <span>${formatCurrency(item.vProd)}</span>
                </p>`;
            });
        }

        // Total
        recibo += "<hr>";
        if (nota.vFrete) {
            recibo += `<p><strong>Frete:</strong> ${formatCurrency(nota.vFrete)}</p>`;
        }
        recibo += `<p><strong>Total:</strong> ${formatCurrency(nota.vNota)}</p>`;
        recibo += "<hr>";        

        // Mensagem de agradecimento
        recibo += `<p style="text-align: center;">OBRIGADO, VOLTE SEMPRE!</p>`;
        recibo += "<hr>";

        recibo += `</body></html>`;

        return recibo;
    };

    const printRecibo = useCallback(async (notaId) => {
        try {
            const nota = await buscaNotaById(notaId);
            const conteudoImpressao = await gerarRecibo(notaId);
            if (!conteudoImpressao) return;

            const janelaImpressao = window.open('', '', 'width=800,height=600');
            janelaImpressao.document.write(conteudoImpressao);
            janelaImpressao.document.close();

            janelaImpressao.onload = () => {
                janelaImpressao.print();
                janelaImpressao.close();

                // Após imprimir recibo, imprime tickets de alimentação
                setTimeout(async () => {
                    let numTicket = 0;                

                    for (const item of nota.notaItens || []) {
                        if (item?.produto?.geraTicket) {
                            const qtd = Math.floor(item.qtdCom || 1);
                            for (let i = 0; i < qtd; i++) {
                                numTicket++;
                                const conteudoTicket = gerarTicketProduto(item, nota, numTicket);

                                // Abrir e imprimir o ticket
                                const janelaTicket = window.open('', '_blank', 'width=800,height=600');
                                if (!janelaTicket) {
                                    showMessage('Pop-up bloqueado ao tentar imprimir ticket.', 'danger');
                                    return;
                                }

                                janelaTicket.document.write(conteudoTicket);
                                janelaTicket.document.close();

                                await new Promise(resolve => {
                                    janelaTicket.onload = () => {
                                        janelaTicket.print();
                                        janelaTicket.close();
                                        resolve(); // Só continua após fechar
                                    };
                                });

                                // Aguarda um pequeno intervalo antes de prosseguir para o próximo ticket
                                await new Promise(res => setTimeout(res, 200)); // Opcional                            
                            }
                        }
                    }
                }, 300);
            };

        } catch (error) {
            showMessage('Erro ao imprimir o recibo.', 'danger');
            console.error(error);
        }
    }, [showMessage, isConfigLoaded]);




    // Função para gerar a NFC-e (mantida como está)
    const geraViaNFCe = (nota) => {
        let recibo = `<html>
            <head>
                <title>Impressão</title>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>
                <style>
                    @page { size: 72mm auto; margin: 0; }
                    body { font-family: 'Draft', monospace; font-size: 12px; margin: 0; padding: 10px; width: 72mm; }
                    
                    h2, h3 { 
                        text-align: center; 
                        margin-top: 2px; 
                        margin-bottom: 2px; 
                    }
    
                    hr { border: 1px dashed black; }
                    p { margin: 2px 0; text-align: center; }
                    .item-row { display: flex; justify-content: space-between; }
                    .item-table { width: 100%; border-collapse: collapse; }                    
                    ${configModuloSel.printValUnRec? ".item-table th, .item-table td { padding: 2px; text-align: left; font-size: 11px; }": ".item-table th, .item-table td { padding: 2px; text-align: left; font-size: 12px; }" }
                    .item-table th { font-weight: bold; }
                    .green { color: green; }
                    .red { color: red; }
                    .tef-comprovante {
                        margin: 2px 0;
                        max-width: 100%;
                        font-family: 'Draft', monospace;
                        font-size: 10px;
                        line-height: 1.15;
                        text-align: left;
                        white-space: pre-wrap;
                        overflow-wrap: anywhere;
                        word-break: break-word;
                    }
                </style>
            </head>
            <body>`;
    
        recibo += "<hr>";
        recibo += `<h2>${nota.filial.empresa.nome}</h2>`;
        recibo += "<hr>";
    
        // Dados da filial
        recibo += `<p>CNPJ: ${nota.filial.cnpj} IE: ${nota.filial.ie}</p>`;
        const endereco1 = `${nota.filial.endereco.logradouro}, ${nota.filial.endereco.numero}, ${nota.filial.endereco.bairro}, `
        +`${nota.filial.endereco.cidade.nome}, ${nota.filial.endereco.cidade.uf}`;        
        //const endereco2 = `${nota.filial.endereco.cidade.nome}, ${nota.filial.endereco.cidade.uf}, Fone: ${configWhats.telefone}`;
        const endereco2 = (nota.filial.telefone ? `Fone: ${formatTelefone(nota.filial.telefone)}` : '');
        recibo += `<p>${endereco1}</p>`;
        recibo += `<p>${endereco2}</p>`;
        recibo += "<hr>";
    
        // Documento
        recibo += `<p>DOCUMENTO AUXILIAR DA NFC-e</p>`;
        recibo += "<hr>";
    
        // Número, série e data de emissão
        const numeroSerie = `Número: ${nota.numDoc}  Série: ${nota.serie}`;

        // Data e hora de emissão formatadas
        const dataEmissao = new Date(nota.dataEmissao).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        // Linha dupla conforme solicitado
        recibo += `
            <p>${numeroSerie}</p>
            <p>Emissão: ${dataEmissao}</p>
        `;
    
        // Informações do cliente
        recibo += `<p><strong>Cliente:</strong> ${nota.clienteNome}</p>`;
        if (nota.cpf) recibo += `<p><strong>CPF:</strong> ${nota.cpf}</p>`;
        if (nota.cnpj) recibo += `<p><strong>CNPJ:</strong> ${nota.cnpj}</p>`;
        recibo += "<hr>";

        // Observação da nota (se houver)
        if (nota.observacao && nota.observacao.trim() !== "") {
            recibo += `
                <p><strong>Observação:</strong></p>
                <p style="font-size: 12px; text-align: left; margin-top: 3px;">
                    ${nota.observacao.toUpperCase()}
                </p>
                <hr>
            `;
        }

        recibo += `<h3>Itens</h3>`;
        if (configModuloSel.printValUnRec) {
            //console.log('configModuloList:', configModuloList); // Debug
            
            // Cabeçalho com valor unitário
            recibo += `
                <table class="item-table">
                        <tr>
                            <th style="width: 5%;">SEQ</th>
                            <th style="width: 50%;">DESCRICAO</th>
                            <th style="width: 10%; text-align: right;">QTDE</th>
                            <th style="width: 5%; text-align: center;">UN</th>
                            <th style="width: 10%; text-align: right;">UNIT</th>
                            <th style="width: 15%; text-align: right;">TOTAL</th>
                        </tr>`;
            
            nota.notaItens.forEach(item => {
                const descricaoTruncada = item?.xProd?.substring(0, 18).toUpperCase() || ''; // Limita a 20 caracteres
                recibo += `
                    <tr>
                        <td>${String(item?.item).padStart(3, '0')}</td>
                        <td>${descricaoTruncada}</td>
                        <td style="text-align: right;">${item?.qtdCom.toFixed(3).replace(".", ",")}</td>
                        <td style="text-align: center;">${item?.unCom}</td>
                        <td style="text-align: right;">${item?.vUnCom.toFixed(2).replace(".", ",")}</td>
                        <td style="text-align: right;">${item?.vProd.toFixed(2).replace(".", ",")}</td>
                    </tr>`;
            });

            recibo += `</table>`

        } else {    

            nota.notaItens.forEach(item => {                
                const descricao = `${item.qtdCom}x ${item?.xProd.toUpperCase()}`;
                const descricaoTruncada = descricao.substring(0, 24) || ''; // Limita a 24 caracteres                
                recibo += `<p style="display: flex; justify-content: space-between; font-size: 14px; font-weight: bold;">
                    <span>${descricaoTruncada}</span>
                    <span>${formatCurrency(item.vProd)}</span>
                </p>`;            
            });
        }
    
        // Pagamento e total
        recibo += "<hr>";
        recibo += `<p><strong>Pagamento:</strong> ${nota.notaPags[0]?.formaPag?.descricao || 'Desconhecido'}</p>`;
        if (nota.vFrete) {
            recibo += `<p><strong>Frete:</strong> ${formatCurrency(nota.vFrete)}</p>`;
        }
        if (nota.vOutro) {
            recibo += `<p><strong>Acréscimo:</strong> ${formatCurrency(nota.vOutro)}</p>`;
        }
        if (nota.vDesc) {
            recibo += `<p><strong>Desconto:</strong> ${formatCurrency(nota.vDesc)}</p>`;
        }
        recibo += `<p><strong>Total:</strong> ${formatCurrency(nota.vNota)}</p>`;
    
        if (nota.notaPags[0]?.vTroco)
            recibo += `<p><strong>Troco:</strong> R$ ${nota.notaPags[0]?.vTroco?.toFixed(2) || '0.00'}</p>`;
    
        // Chave e QR Code
        recibo += "<hr>";
        recibo += `<p><strong>Chave NFC-e:</strong></p>`;
        recibo += `<p style="display: flex; justify-content: center; font-size: 11px; margin: 2px;">${nota.chave}</p>`;
        recibo += `<div id="qrcode" style="display: flex; justify-content: center; margin: 10px;"></div>`;
        recibo += "<hr>";
        
        // Colocar dados do TEF (comprovante)
        const comprovantesTEF = nota.notaPags
            .map(pag => pag.tefComprovante)
            .filter(txt => txt); // Remove nulos/vazios

        if (comprovantesTEF.length > 0) {
            //recibo += `<hr>`;
            recibo += `<p><strong>Comprovante TEF</strong></p>`;

            comprovantesTEF.forEach(raw => {
                // Divide pelo padrão de strings entre aspas duplas separadas por espaço
                if (isComprovanteMSitef(raw)) {
                    // O JSON é interpretado para preservar as linhas e os espaços do comprovante.
                    recibo += `<div class="tef-comprovante">${formataComprovanteTEF(raw)}</div>`;
                } else {
                    const regex = /"(.*?)"/g;
                    const linhas = [...raw.matchAll(regex)].map(m => m[1]);

                    linhas.forEach(linha => {
                        // Centraliza cada linha
                        recibo += `<p style="text-align: center;">${linha}</p>`;
                    });
                }

                recibo += `<hr>`;
            });
        }
    
        // Mensagem de agradecimento
        recibo += `<p>Obrigado pela preferência!</p>`;
        recibo += `</body>
            <script>
                // Gera o QR Code dentro do elemento 'qrcode'
                new QRCode(document.getElementById("qrcode"), {
                    text: "${nota.qrCode}",
                    width: 128,
                    height: 128
                });
            </script>
        </html>`;
        
        return recibo;
    };

    const geraViaNFCeCelular = (nota) => {
        let recibo = `<html>
            <head>
                <title>Impressão NFC-e</title>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>
                <style>
                    @page { size: A4 portrait; margin: 0; }
                    body { font-family: monospace; font-size: 31.5px; margin: 0; padding: 26.25px; width: 210mm; }
                    html, body {
                        height: auto !important;
                        overflow: visible !important;
                    }
                    h2, h3 { text-align: center; margin: 5.25px 0; }
                    hr { border: 2.65px dashed #000; margin: 13.12px 0; }
                    p { margin: 5.25px 0; text-align: center; }
                    .item-table { width: 100%; border-collapse: collapse; }
                    .item-table th, .item-table td { padding: 5.25px; font-size: 31.5px; text-align: left; }
                    .item-table th { font-weight: bold; }
                    .tef-linha {
                        text-align: center;
                        white-space: pre-wrap; /* <= importante */
                        word-break: break-word;
                    }
                    .tef-comprovante {
                        margin: 5.25px 0;
                        max-width: 100%;
                        font-family: monospace;
                        font-size: 26px;
                        line-height: 1.15;
                        text-align: left;
                        white-space: pre-wrap;
                        overflow-wrap: anywhere;
                        word-break: break-word;
                    }
                </style>
            </head>
            <body>`;

        recibo += `<h2>${nota.filial.empresa.nome}</h2>`;
        recibo += `<hr>`;
        recibo += `<p>CNPJ: ${nota.filial.cnpj} | IE: ${nota.filial.ie}</p>`;
        recibo += `<p>${nota.filial.endereco.logradouro}, ${nota.filial.endereco.numero}, ${nota.filial.endereco.bairro}</p>`;
        //recibo += `<p>${nota.filial.endereco.cidade.nome}, ${nota.filial.endereco.cidade.uf}, Fone: ${configWhats.telefone}</p>`;
        recibo += `<p>${nota.filial.endereco.cidade.nome}, ${nota.filial.endereco.cidade.uf}</p>`;
        recibo += `<hr>`;
        recibo += `<p>DOCUMENTO AUXILIAR DA NFC-e</p>`;
        recibo += `<hr>`;

        // Número, série e hora
        // Número, série e data de emissão
        const numeroSerie = `Número: ${nota.numDoc}  Série: ${nota.serie}`;

        // Data e hora de emissão formatadas
        const dataEmissao = new Date(nota.dataEmissao).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        // Linha dupla conforme solicitado
        recibo += `
            <p>${numeroSerie}</p>
            <p>Emissão: ${dataEmissao}</p>
        `;
        

        // Cliente
        recibo += `<p><strong>Cliente:</strong> ${nota.clienteNome}</p>`;
        if (nota.cpf) recibo += `<p><strong>CPF:</strong> ${nota.cpf}</p>`;
        if (nota.cnpj) recibo += `<p><strong>CNPJ:</strong> ${nota.cnpj}</p>`;
        recibo += `<hr>`;

        // Observação da nota (se houver)
        if (nota.observacao && nota.observacao.trim() !== "") {
            recibo += `
                <p><strong>Observação:</strong></p>
                <p style="font-size: 12px; text-align: left; margin-top: 3px;">
                    ${nota.observacao.toUpperCase()}
                </p>
                <hr>
            `;
        }

        // Itens
        recibo += `<h3>Itens</h3>`;
        
        nota.notaItens.forEach((item) => {
            const descricao = `${item.qtdCom}x ${item?.xProd.toUpperCase()}`;
            
            // limita a 43 caracteres
            let descricaoTruncada = descricao.substring(0, 30) || "";

            // calcula quantos espaços faltam
            const larguraMax = 30;
            const faltando = larguraMax - descricaoTruncada.length;

            // adiciona espaços em branco até completar
            descricaoTruncada = descricaoTruncada + "&nbsp;".repeat(faltando);

            recibo += `<h3>${descricaoTruncada} ${formatCurrency(item.vProd)}</h3>`;
        });

        recibo += `</table>`;
        recibo += `<hr>`;

        // Totais
        recibo += `<p><strong>Pagamento:</strong> ${nota.notaPags[0]?.formaPag?.descricao || "Desconhecido"}</p>`;
        if (nota.vFrete) recibo += `<p><strong>Frete:</strong> ${formatCurrency(nota.vFrete)}</p>`;
        recibo += `<p><strong>Total:</strong> ${formatCurrency(nota.vNota)}</p>`;
        if (nota.notaPags[0]?.vTroco)
            recibo += `<p><strong>Troco:</strong> ${formatCurrency(nota.notaPags[0]?.vTroco)}</p>`;

        recibo += `<hr>`;
        recibo += `<p><strong>Chave NFC-e:</strong></p>`;
        recibo += `<p style="font-size: 28px;">${nota.chave}</p>`;
        recibo += `<div id="qrcode" style="display:flex; justify-content:center; margin:20px;"></div>`;
        recibo += `<hr>`;

        // Colocar dados do TEF (comprovante)
        const comprovantesTEF = nota.notaPags
            .map(pag => pag.tefComprovante)
            .filter(txt => txt); // Remove nulos/vazios

        if (comprovantesTEF.length > 0) {
            recibo += "<p><strong>Comprovante TEF</strong></p>";            

            comprovantesTEF.forEach(raw => {
                // Divide pelo padrão de strings entre aspas duplas separadas por espaço
                if (isComprovanteMSitef(raw)) {
                    // O JSON é interpretado para preservar as linhas e os espaços do comprovante.
                    recibo += `<div class="tef-comprovante">${formataComprovanteTEF(raw)}</div>`;
                } else {
                    const regex = /"(.*?)"/g;
                    const linhas = [...raw.matchAll(regex)].map(m => m[1]);

                    linhas.forEach(linha => {
                        // Centraliza cada linha
                        recibo += `<p style="text-align: center;">${linha}</p>`;
                    });
                }

                recibo += `<hr>`;
            });            
        }

        recibo += `<p style="text-align:center;">Obrigado pela preferência!</p>`;
        recibo += `</body>
            <script>
                new QRCode(document.getElementById("qrcode"), {
                    text: "${nota.qrCode}",
                    width: 256,
                    height: 256
                });
            </script>
        </html>`;

        return recibo;
    };

    
    const visualizarNFCe = useCallback(async (notaId) => {
        try {
            const nota = await buscaNotaById(notaId);

            let conteudoImpressao;
            if (configModuloSel?.printCelular)
                conteudoImpressao = geraViaNFCeCelular(nota);
            else
                conteudoImpressao = geraViaNFCe(nota);

            if (!conteudoImpressao) return;

            const janelaVisualizacao = window.open('', '_blank');
            if (!janelaVisualizacao) {
                showMessage('Pop-up bloqueado ao tentar visualizar a NFC-e.', 'warning');
                return;
            }

            janelaVisualizacao.document.write(conteudoImpressao);
            janelaVisualizacao.document.close();
        } catch (error) {
            showMessage('Erro ao visualizar a NFC-e.', 'danger');
            console.error(error);
        }
    }, [showMessage, isConfigLoaded, configModuloSel, buscaNotaById]);

    const printNFCe = useCallback(async (notaId) => {
        try {
            const nota = await buscaNotaById(notaId);
            

            let conteudoImpressao;
            if (configModuloSel?.printCelular)
                conteudoImpressao = geraViaNFCeCelular(nota);
            else
                conteudoImpressao = geraViaNFCe(nota);
        
            if (!conteudoImpressao) return;


            const janelaImpressao = window.open();
            janelaImpressao.document.write(conteudoImpressao);
            janelaImpressao.document.close();

            // Aguarda carregar a NFC-e antes de imprimir
            janelaImpressao.onload = () => {
                janelaImpressao.print();
                janelaImpressao.close();

                // Após imprimir NFC-e, imprime os tickets de alimentação
                setTimeout(async () => {
                    let numTicket = 0;

                    for (const item of nota.notaItens || []) {
                        if (item?.produto?.geraTicket) {
                            const qtd = Math.floor(item.qtdCom || 1);

                            for (let i = 0; i < qtd; i++) {
                                numTicket++;
                                const conteudoTicket = gerarTicketProduto(item, nota, numTicket);

                                const janelaTicket = window.open('', '_blank', 'width=800,height=600');
                                if (!janelaTicket) {
                                    showMessage('Pop-up bloqueado ao tentar imprimir ticket.', 'danger');
                                    return;
                                }

                                janelaTicket.document.write(conteudoTicket);
                                janelaTicket.document.close();

                                await new Promise(resolve => {
                                    janelaTicket.onload = () => {
                                        janelaTicket.print();
                                        janelaTicket.close();
                                        resolve();
                                    };
                                });

                                // Intervalo opcional entre tickets
                                await new Promise(res => setTimeout(res, 100));
                            }
                        }
                    }
                }, 100); // Espera a impressão da NFC-e terminar
            };
        } catch (error) {
            showMessage('Erro ao imprimir a NFC-e.', 'danger');
            console.error(error);
        }
    }, [showMessage, isConfigLoaded]);

//SE FOR NO PC USAR ESTA ROTINA
// Função para gerar o recibo de pedido
const gerarReciboPedido = async (pedido) => {
    if (!pedido || !pedido.pedidoItens || !pedido.pedidoItens.length) {
        showMessage("Nenhum item no pedido para imprimir.", "warning");
        return "";
    }

    const tipoEntregaDescricao = pedido.tipoEntrega?.descricao?.toLowerCase() || '';
    const tipoEntregaDescricaoNormalizada = tipoEntregaDescricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const getIconEntrega = () => {
        switch (true) {        
            case tipoEntregaDescricaoNormalizada.includes('retirada'):
                return <FaShoppingBag className="print-react-icon" />;            
            case tipoEntregaDescricaoNormalizada.includes('delivery'):
                return <FaMotorcycle className="print-react-icon" />;
            case tipoEntregaDescricaoNormalizada.includes('mesa'):
                return <MdOutlineTableBar className="print-react-icon print-react-icon-outline" />;
            case tipoEntregaDescricaoNormalizada.includes('consumir'):
                return <FaUtensils className="print-react-icon" />;
            default:
                return <FaMotorcycle className="print-react-icon" />;
        }
    };
    const iconPedido = renderToStaticMarkup(<FaReceipt className="print-react-icon" />);
    const iconPrevisao = renderToStaticMarkup(<FaClock className="print-react-icon" />);
    const iconCliente = renderToStaticMarkup(<FaUser className="print-react-icon" />);
    const iconTelefone = renderToStaticMarkup(<FaPhoneAlt className="print-react-icon" />);
    const iconEndereco = renderToStaticMarkup(<FaMapMarkerAlt className="print-react-icon" />);
    const iconObservacao = renderToStaticMarkup(<FaRegStickyNote className="print-react-icon" />);
    const iconEntrega = renderToStaticMarkup(getIconEntrega());

    let recibo = `
    <html>
    <head>
        <title>Impressão de Pedido</title>
        <style>
            @page { size: auto; margin: 0; }

            body {
                font-family: monospace;
                font-size: 15px;      /* ⬅ aumenta a fonte geral */
                margin: 0;
                padding: 10px;
                width: 72mm;
                line-height: 1.3;     /* ⬅ melhora a leitura */
            }

            h1 {
                text-align: center;
                font-size: 24px;      /* ⬅ título bem visível */
                margin: 0px;
            }

            h2 {
                text-align: center;
                font-size: 18px;      /* ← título bem visível */
                margin: 4px 0;
            }

            h3 {
                text-align: center;
                font-size: 16px;
                margin: 4px 0;
            }

            hr {
                border: 1px dashed #000;
                margin: 6px 0;
            }

            p {
                margin: 2px 0;
                font-size: 15px;
            }

            .item-table {
                width: 100%;
                border-collapse: collapse;
                table-layout: auto;
            }

            .item-table th,
            .item-table td {
                padding: 2px 1px;
                vertical-align: top;
            }

            /* Descrição */
            .col-desc {
                text-align: left;
                width: auto;
            }

            /* Quantidade */
            .col-qtd {
                text-align: center;
                width: 1%;
                white-space: nowrap;
                padding-right: 4px; /* ⬅ empurra mais pra direita */
            }

            /* Valor */
            .col-valor {
                text-align: right;
                width: 1%;
                white-space: nowrap;
            }

            .logo-empresa {
                display: block;
                margin: 0 auto 0px;
                max-width: 150px;
                max-height: 150px;
                object-fit: contain;
            }
                    

            .indent {
                padding-left: 8px;
                font-size: 15px;
                padding: 2px 1px;
            }

            .total {
                text-align: right;
                font-weight: bold;
                font-size: 16px;      /* ⬅ total bem destacado */
                margin-top: 4px;
            }

            body {
                font-family: "Segoe UI", Arial, sans-serif;
                font-size: 14px;
                padding: 8px;
                line-height: 1.35;
                color: #000;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            .recibo {
                width: 100%;
            }

            .topo-recibo {
                text-align: center;
                border-bottom: 2px solid #000;
                padding-bottom: 6px;
                margin-bottom: 6px;
            }

            .pedido-numero {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                border: 2px solid #000;
                border-radius: 6px;
                padding: 5px 4px;
                margin: 7px 0 6px;
                background: #f2f2f2;
                font-size: 20px;
                letter-spacing: 0;
            }

            .pedido-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                flex: 0 0 20px;
            }

            .bloco-info {
                border-top: 1px dashed #000;
                border-bottom: 1px dashed #000;
                padding: 5px 0;
                margin: 6px 0;
            }

            .info-line {
                display: flex;
                gap: 4px;
                align-items: flex-start;
                margin: 2px 0;
                font-size: 14px;
                font-weight: 600;
            }

            .info-icon {
                position: relative;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 18px;
                height: 18px;
                flex: 0 0 18px;
                text-align: center;
            }

            .print-react-icon {
                display: block;
                width: 18px;
                height: 18px;
                color: #000;
                fill: #000;
                stroke: #000;
                stroke-width: 6;
            }

            .pedido-icon .print-react-icon {
                width: 20px;
                height: 20px;
                stroke-width: 5;
            }

            .print-react-icon-outline {
                stroke-width: 0;
            }

            .footer-icon {
                display: inline-block;
                width: 10px;
                height: 10px;
                margin: 0 4px;
                color: #000;
                fill: #000;
                vertical-align: -1px;
            }

            .moto-react-icon {
                display: block;
                width: 18px;
                height: 18px;
                color: #000;
                fill: #000;
                stroke: #000;
                stroke-width: 12;
            }

            .info-label {
                font-weight: 800;
            }

            .section-title {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 5px;
                border-bottom: 1px solid #000;
                padding-bottom: 4px;
                margin: 8px 0 5px;
                font-size: 16px;
                font-weight: 800;
                letter-spacing: 0;
            }

            .item-table th {
                font-size: 13px;
                text-transform: uppercase;
                border-bottom: 1px solid #000;
            }

            .item-table tr.item-row td {
                border-bottom: 0;
            }

            .item-table tr.item-separator td {
                border-bottom: 1px dotted #777;
                padding: 2px 0 0;
                height: 1px;
                line-height: 1px;
            }

            .col-desc {
                width: auto;
                overflow-wrap: anywhere;
            }

            .col-qtd {
                width: 1%;
                white-space: nowrap;
                font-weight: 700;
            }

            .col-valor {
                width: 1%;
                white-space: nowrap;
                font-weight: 700;
            }

            .produto-nome {
                font-weight: 700;
            }

            .indent {
                padding-left: 12px !important;
                font-size: 14px;
                color: #111;
            }

            .indent .print-react-icon {
                display: inline-block;
                width: 10px;
                height: 10px;
                margin-right: 3px;
                vertical-align: -1px;
                stroke-width: 8;
            }

            .resumo {
                border-top: 2px solid #000;
                border-bottom: 2px solid #000;
                padding: 5px 0;
                margin-top: 7px;
            }

            .resumo-linha {
                display: flex;
                justify-content: space-between;
                gap: 8px;
                font-weight: 700;
                margin: 2px 0;
                font-size: 14px;
            }

            .resumo-total {
                font-size: 18px;
                font-weight: 900;
                margin-top: 5px;
                padding-top: 5px;
                border-top: 1px dashed #000;
            }

            .footer-message {
                text-align: center;
                font-size: 13px;
                font-weight: 800;
                margin-top: 8px;
                padding-top: 4px;
            }
        </style>

    </head>
    <body>
    `;

    const getImageMimeType = (base64) => {
        if (!base64) return 'image/png';
        if (base64.startsWith('/9j/')) return 'image/jpeg';
        if (base64.startsWith('iVBOR')) return 'image/png';
        if (base64.startsWith('R0lGOD')) return 'image/gif';
        if (base64.startsWith('UklGR')) return 'image/webp';
        return 'image/png';
    };

    let nomeEmpresa;
    let logoCabecalho = logoFilialLogin;
    if (!filialLogin){
        var result = await fetchFiliais();
        const filialAtual = result?.[0];
        nomeEmpresa = filialAtual?.empresa?.nome || 'Minha Empresa';
        if (filialAtual?.id) {
            logoCabecalho = await fetchFilialLogo(filialAtual.id);
        }
    } else {
        nomeEmpresa = filialLogin.empresa.nome;
        if (!logoCabecalho && filialLogin.id) {
            logoCabecalho = await fetchFilialLogo(filialLogin.id);
        }
    }

    recibo += `<div class="topo-recibo">`;
    if (logoCabecalho) {
        recibo += `<img class="logo-empresa" src="data:${getImageMimeType(logoCabecalho)};base64,${logoCabecalho}" alt="Logo da empresa" />`;
    } else {
        recibo += `<h1>${nomeEmpresa}</h1>`;
    }
    recibo += `</div>`;
    recibo += `<h2 class="pedido-numero"><span class="pedido-icon">${iconPedido}</span><span>PEDIDO Nº ${getNumeroPedido(pedido, configModuloSel)}</span></h2>`;
    recibo += `<div class="bloco-info">`;
    recibo += `<p class="info-line"><span class="info-icon">${iconCliente}</span><span><span class="info-label">Cliente:</span> ${pedido.cliente?.nome || pedido.nomeCliente || 'NÃO IDENTIFICADO'}</span></p>`;
    if (pedido.telefoneCliente) recibo += `<p class="info-line"><span class="info-icon">${iconTelefone}</span><span><span class="info-label">Telefone:</span> ${pedido.telefoneCliente}</span></p>`;
    if (pedido.tipoEntrega) recibo += `<p class="info-line"><span class="info-icon">${iconEntrega}</span><span><span class="info-label">Entrega:</span> ${pedido.tipoEntrega.descricao}</span></p>`;
    if (pedido.enderecoCliente || pedido.endereco?.logradouro) {
        const endereco = pedido.endereco?.logradouro
            ? `${pedido.endereco.logradouro}, ${pedido.endereco.numero || ''} ${pedido.endereco.bairro || ''}`
            : pedido.enderecoCliente;
        recibo += `<p class="info-line"><span class="info-icon">${iconEndereco}</span><span><span class="info-label">Endereço:</span> ${endereco}</span></p>`;
    }
    //Luan XdoBIl quer que imprime a previsão de entrega no recibo
    if (pedido.horaPrevisao && configModuloSel.imprimePrevisao) recibo += `<p class="info-line"><span class="info-icon">${iconPrevisao}</span><span><span class="info-label">Previsão:</span> ${pedido.horaPrevisao}</span></p>`;    
    if (pedido.observacao?.trim()) {
        recibo += `<p class="info-line"><span class="info-icon">${iconObservacao}</span><span><span class="info-label">Observação:</span> ${pedido.observacao}</span></p>`;
    }
    recibo += `</div>`;
    recibo += `<h3 class="section-title"><span>Itens do pedido</span></h3>`;
    recibo += `<table class="item-table">`;
    recibo += `
        <tr>
            <th class="col-qtd">Qtd</th>
            <th class="col-desc">Item</th>
            <th class="col-valor">Valor</th>
        </tr>`;

    const conjuntosCache = new Map();

    const obterConjuntoImpressao = async (conjuntoId) => {
        if (!conjuntoId) return null;
        if (conjuntosCache.has(conjuntoId)) return conjuntosCache.get(conjuntoId);

        const conjunto = await fetchConjuntoById(conjuntoId);
        conjuntosCache.set(conjuntoId, conjunto);
        return conjunto;
    };

    for (const item of pedido.pedidoItens) {
        const descricao = `${item.produto?.descricao || 'Produto'}${formatarVariacoes(item) ? ' - ' + formatarVariacoes(item) : ''}`;
        recibo += `
        <tr class="item-row">
            <td class="col-qtd">${item.qtde}x</td>
            <td class="col-desc"><span class="produto-nome">${descricao}</span></td>
            <td class="col-valor">${formatCurrency(item.valorTotal)}</td>
        </tr>`;

        // Conjuntos
        if (Array.isArray(item.pedidoItemConjuntos) && item.pedidoItemConjuntos.length > 0) {
            const agrupados = item.pedidoItemConjuntos.reduce((acc, curr) => {
                const conjuntoId = curr.conjuntoId || curr.ConjuntoId || curr.conjunto?.id || curr.Conjunto?.id || 0;
                const nome = curr.nomeConjunto || 'Sem nome';
                const chave = `${conjuntoId}|${nome}`;
                if (!acc[chave]) acc[chave] = { conjuntoId, nomeConjunto: nome, itens: [] };
                acc[chave].itens.push(curr);
                return acc;
            }, {});

            for (const { conjuntoId, nomeConjunto, itens } of Object.values(agrupados)) {                
                const conjunto = await obterConjuntoImpressao(conjuntoId);
                const qtdTotalSelecionada = itens.reduce((total, itemConjunto) => {
                    return total + parseNumero(itemConjunto?.qtdItens ?? itemConjunto?.QtdItens ?? 1);
                }, 0);
                recibo += `<tr><td colspan="3" class="indent"><strong>↳ ${nomeConjunto}:</strong></td></tr>`;
                for (const it of itens) {
                    const desc = it.descricao || 'Item sem descrição';
                    const qtd = getQtdConjuntoImpressao(it, conjunto, qtdTotalSelecionada);
                    const adicional = parseFloat(it.valorAdicional) > 0
                        ? ` - ${formatCurrency(it.valorAdicional)}`
                        : '';
                    recibo += `<tr><td colspan="3" class="indent">• ${qtd} ${desc} ${adicional}</td></tr>`;
                }
            }
        }

        // Adicionais
        if (item.pedidoItemAdicionais && item.pedidoItemAdicionais.length > 0) {
            for (const ad of item.pedidoItemAdicionais) {
                recibo += `<tr><td colspan="3" class="indent">＋ ${ad.adicional?.descricao || 'Adicional'} (${formatCurrency(ad.valor)})</td></tr>`;
            }
        }

        // Observação
        if (item.observacao) {
            recibo += `<tr><td colspan="3" class="indent">${iconObservacao} Obs.: ${item.observacao}</td></tr>`;
        }

        recibo += `<tr class="item-separator"><td colspan="3"></td></tr>`;
    }

    recibo += `</table>`;
    recibo += `<div class="resumo">`;
    if (pedido.valorDesconto > 0 || pedido.taxaEntrega > 0) {
        recibo += `<p class="resumo-linha"><span>Subtotal</span><span>${formatCurrency(pedido.valorItens)}</span></p>`;
    }
    if (pedido.valorDesconto > 0) {
        recibo += `<p class="resumo-linha"><span>Desconto</span><span>- ${formatCurrency(pedido.valorDesconto)}</span></p>`;
    }
    if (pedido.valorAcrescimo > 0) {
        recibo += `<p class="resumo-linha"><span>Acréscimo</span><span>+${formatCurrency(pedido.valorAcrescimo)}</span></p>`;
    }
    if (pedido.taxaEntrega > 0) {
        recibo += `<p class="resumo-linha"><span>Entrega</span><span>${formatCurrency(pedido.taxaEntrega)}</span></p>`;
    }
    recibo += `<p class="resumo-linha resumo-total"><span>Total</span><span>${formatCurrency(pedido.valorTotal)}</span></p>`;
    if (pedido.valorCashBack > 0) {
        recibo += `<p class="resumo-linha"><span>CashBack</span><span>- ${formatCurrency(pedido.valorCashBack)}</span></p>`;
    }
    if (pedido.formaPag?.descricao) {
        recibo += `<p class="resumo-linha"><span>Pagamento</span><span>${pedido.formaPag?.descricao}</span></p>`;
    }
    
    if (pedido.trocoPara > 0) {
        recibo += `<p class="resumo-linha"><span>Troco para</span><span>${formatCurrency(pedido.trocoPara)}</span></p>`;
    }
    recibo += `</div>`;
    recibo += `<p class="footer-message">OBRIGADO, VOLTE SEMPRE!</p>`;
    recibo += `</div>`;
    recibo += `</body></html>`;

    return recibo;
};

// Função para imprimir o recibo de pedido
const printReciboPedido = useCallback(async (pedido) => {
    try {
        let conteudoImpressao;
        
        conteudoImpressao = await gerarReciboPedido(pedido);

        if (!conteudoImpressao) return;

        const janelaImpressao = window.open();
        if (!janelaImpressao) {
            showMessage('Pop-up bloqueado ao tentar imprimir o pedido.', 'warning');
            return;
        }

        janelaImpressao.document.write(conteudoImpressao);
        janelaImpressao.document.close();

        janelaImpressao.onload = () => {
            janelaImpressao.print();
            janelaImpressao.close();
        };
    } catch (error) {
        showMessage('Erro ao imprimir o pedido.', 'danger');
        console.error(error);
    }
}, [showMessage, isConfigLoaded]);;

const printPedidoPDFById = useCallback(async (pedidoId, paperWidthMm = 75) => {
    try {
        if (!pedidoId) {
            showMessage('Pedido não informado para impressão.', 'warning');
            return false;
        }

        const pdfBlob = await getPedidoPDFByIdService({ pedidoId, paperWidthMm });
        const blob = pdfBlob?.type === 'application/pdf'
            ? pdfBlob
            : new Blob([pdfBlob], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        const frameExistente = document.getElementById('pedido-pdf-print-frame');

        if (frameExistente) {
            frameExistente.remove();
        }

        const frame = document.createElement('iframe');
        frame.id = 'pedido-pdf-print-frame';
        frame.title = 'Impressão de Pedido';
        frame.style.position = 'fixed';
        frame.style.right = '0';
        frame.style.bottom = '0';
        frame.style.width = '1px';
        frame.style.height = '1px';
        frame.style.border = '0';
        frame.style.opacity = '0';
        frame.style.pointerEvents = 'none';
        frame.src = pdfUrl;
        document.body.appendChild(frame);

        let impressaoSolicitada = false;
        let cleanupSolicitado = false;

        const cleanup = () => {
            if (cleanupSolicitado) {
                return;
            }
            cleanupSolicitado = true;
            frame.remove();
            URL.revokeObjectURL(pdfUrl);
        };

        const imprimirPDF = () => {
            if (impressaoSolicitada) {
                return;
            }
            impressaoSolicitada = true;

            try {
                frame?.contentWindow?.focus();
                frame?.contentWindow?.print();
            } catch (error) {
                console.error('Erro ao abrir a impressão do PDF do pedido:', error);
                showMessage('Não foi possível abrir a impressão do PDF do pedido.', 'warning');
                cleanup();
            } finally {
                frame.contentWindow?.addEventListener?.('afterprint', cleanup, { once: true });
                setTimeout(cleanup, 60000);
            }
        };

        frame.onload = () => setTimeout(imprimirPDF, 300);
        setTimeout(imprimirPDF, 1200);

        return true;
    } catch (error) {
        showMessage('Erro ao imprimir o PDF do pedido.', 'danger');
        console.error(error);
        return false;
    }
}, [showMessage]);

const imprimirPdfFiscalEmSequencia = useCallback(async ({
    pdfBlob,
    frameId,
    titulo,
    mensagemErro
}) => {
    const blob = pdfBlob?.type === 'application/pdf'
        ? pdfBlob
        : new Blob([pdfBlob], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    document.getElementById(frameId)?.remove();

    const frame = document.createElement('iframe');
    frame.id = frameId;
    frame.title = titulo;
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '1px';
    frame.style.height = '1px';
    frame.style.border = '0';
    frame.style.opacity = '0';
    frame.style.pointerEvents = 'none';
    frame.src = pdfUrl;
    document.body.appendChild(frame);

    return new Promise((resolve) => {
        let impressaoSolicitada = false;
        let finalizado = false;
        let timeoutSeguranca;
        let intervaloVerificacaoFoco;
        let dialogoImpressaoPerdeuFoco = false;

        const aoPerderFoco = () => {
            dialogoImpressaoPerdeuFoco = true;
        };

        const aoRetornarParaSistema = () => {
            if (dialogoImpressaoPerdeuFoco) {
                setTimeout(() => finalizar(true), 300);
            }
        };

        const verificarFocoImpressao = () => {
            if (!document.hasFocus()) {
                dialogoImpressaoPerdeuFoco = true;
                return;
            }

            if (dialogoImpressaoPerdeuFoco) {
                finalizar(true);
            }
        };

        const finalizar = (sucesso) => {
            if (finalizado) return;
            finalizado = true;
            clearTimeout(timeoutSeguranca);
            clearInterval(intervaloVerificacaoFoco);
            window.removeEventListener('blur', aoPerderFoco);
            window.removeEventListener('focus', aoRetornarParaSistema);
            frame.remove();
            URL.revokeObjectURL(pdfUrl);
            resolve(sucesso);
        };

        const imprimirPDF = () => {
            if (impressaoSolicitada || finalizado) return;
            impressaoSolicitada = true;

            try {
                frame.contentWindow?.addEventListener(
                    'afterprint',
                    () => finalizar(true),
                    { once: true }
                );
                window.addEventListener('blur', aoPerderFoco, { once: true });
                window.addEventListener('focus', aoRetornarParaSistema, { once: true });
                intervaloVerificacaoFoco = setInterval(verificarFocoImpressao, 250);
                frame.contentWindow?.print();
                if (!finalizado) {
                    timeoutSeguranca = setTimeout(() => finalizar(true), 10 * 60 * 1000);
                }
            } catch (error) {
                console.error(mensagemErro, error);
                showMessage(mensagemErro, 'warning');
                finalizar(false);
            }
        };

        frame.onload = () => setTimeout(imprimirPDF, 300);
        setTimeout(imprimirPDF, 1200);
    });
}, [showMessage]);

const imprimirPdfBlob = useCallback(async (pdfBlob, {
    frameId = 'pdf-print-frame',
    titulo = 'Impressão de documento',
    mensagemErro = 'Não foi possível abrir a impressão do documento.'
} = {}) => {
    return await imprimirPdfFiscalEmSequencia({
        pdfBlob,
        frameId,
        titulo,
        mensagemErro
    });
}, [imprimirPdfFiscalEmSequencia]);

const printNFCePDFByIdImediato = useCallback(async (notaId, paperWidthMm = 75) => {
    try {
        if (!notaId) {
            showMessage('Nota não informada para impressão.', 'warning');
            return false;
        }

        const pdfBlob = await getDanfeNFCePDFByNotaIdService({ notaId, paperWidthMm });
        return await imprimirPdfFiscalEmSequencia({
            pdfBlob,
            frameId: 'nfce-pdf-print-frame',
            titulo: 'Impressão de NFC-e',
            mensagemErro: 'Não foi possível abrir a impressão do PDF da NFC-e.'
        });
    } catch (error) {
        showMessage('Erro ao imprimir o PDF da NFC-e.', 'danger');
        console.error(error);
        return false;
    }
}, [imprimirPdfFiscalEmSequencia, showMessage]);

const printNFSePDFByIdImediato = useCallback(async (notaId, paperWidthMm = 75) => {
    try {
        if (!notaId) {
            showMessage('NFS-e não informada para impressão.', 'warning');
            return false;
        }

        const pdfBlob = await getDanfsePDFByNotaIdService({ notaId, paperWidthMm });
        return await imprimirPdfFiscalEmSequencia({
            pdfBlob,
            frameId: 'nfse-pdf-print-frame',
            titulo: 'Impressão de NFS-e',
            mensagemErro: 'Não foi possível abrir a impressão do DANFSe.'
        });
    } catch (error) {
        showMessage('Erro ao imprimir o DANFSe.', 'danger');
        console.error(error);
        return false;
    }
}, [imprimirPdfFiscalEmSequencia, showMessage]);

const enfileirarImpressaoFiscal = useCallback((tarefa) => {
    filaImpressaoFiscalRef.current = filaImpressaoFiscalRef.current
        .catch(() => undefined)
        .then(tarefa)
        .catch((error) => {
            console.error('Erro ao processar a fila de impressão fiscal.', error);
        });

    return filaImpressaoFiscalRef.current;
}, []);

const printNFCePDFById = useCallback(async (notaId, paperWidthMm = 75, aguardarConclusao = false) => {
    if (!notaId) {
        showMessage('Nota não informada para impressão.', 'warning');
        return false;
    }

    const processamento = enfileirarImpressaoFiscal(
        () => printNFCePDFByIdImediato(notaId, paperWidthMm)
    );
    return aguardarConclusao ? await processamento : true;
}, [enfileirarImpressaoFiscal, printNFCePDFByIdImediato, showMessage]);

const printNFSePDFById = useCallback(async (notaId, paperWidthMm = 75, aguardarConclusao = false) => {
    if (!notaId) {
        showMessage('NFS-e não informada para impressão.', 'warning');
        return false;
    }

    const processamento = enfileirarImpressaoFiscal(
        () => printNFSePDFByIdImediato(notaId, paperWidthMm)
    );
    return aguardarConclusao ? await processamento : true;
}, [enfileirarImpressaoFiscal, printNFSePDFByIdImediato, showMessage]);

const printReciboPDFImediato = useCallback(async (notaId, paperWidthMm = 75) => {
    try {
        const pdfBlob = await getReciboPDFByNotaIdService({ notaId, paperWidthMm });
        return await imprimirPdfFiscalEmSequencia({
            pdfBlob,
            frameId: 'recibo-pdf-print-frame',
            titulo: 'Impressão de Recibo',
            mensagemErro: 'Não foi possível abrir a impressão do PDF do recibo.'
        });
    } catch (error) {
        showMessage('Erro ao imprimir o PDF do recibo.', 'danger');
        console.error(error);
        return false;
    }
}, [imprimirPdfFiscalEmSequencia, showMessage]);

const printReciboPDF = useCallback(async (notaId, paperWidthMm = 75) => {
    if (!notaId) {
        showMessage('Nota não informada para impressão.', 'warning');
        return false;
    }

    return await enfileirarImpressaoFiscal(
        () => printReciboPDFImediato(notaId, paperWidthMm)
    );
}, [enfileirarImpressaoFiscal, printReciboPDFImediato, showMessage]);


const printComprovantePagComandaPDF = useCallback(async (comandaId) => {
    return enfileirarImpressaoFiscal(async () => {
        try {
            const pdfBlob = await getComprovantePagComandaPDF(comandaId);
            return await imprimirPdfFiscalEmSequencia({
                pdfBlob,
                frameId: 'comprovante-pag-comanda-print-frame',
                titulo: 'Comprovante de pagamento da comanda',
                mensagemErro: 'Pagamento concluído, mas não foi possível imprimir o comprovante da comanda.'
            });
        } catch (error) {
            console.error('Erro ao imprimir comprovante da comanda:', error);
            return false;
        }
    });
}, [enfileirarImpressaoFiscal, imprimirPdfFiscalEmSequencia]);

const imprimirComprovantePagamento = useCallback(async (comanda, peloMonitor = false) => {
    const chave = `${comanda.id}|${comanda.fechamento}`;
    try {
        if (peloMonitor) {
            await solicitarComprovantePagComandaMonitor(comanda.id);
        } else if (!await printComprovantePagComandaPDF(comanda.id)) {
            throw new Error('Falha ao abrir a impressão.');
        }
        comprovantesPendentesRef.current.delete(chave);
        return true;
    } catch (error) {
        comprovantesPendentesRef.current.set(chave, { comanda, peloMonitor });
        showMessage('Pagamento concluído. O comprovante não foi impresso. Use “Tentar imprimir comprovantes novamente”.', 'warning');
        return false;
    } finally {
        setQuantidadeComprovantesPendentes(comprovantesPendentesRef.current.size);
    }
}, [printComprovantePagComandaPDF, showMessage]);

const imprimirComprovantesQuitados = useCallback(async (antes, depois) => {
    if (!configModuloSel?.comprovantePagComanda) return;
    for (const comanda of selecionarComandasQuitadas(antes, depois)) {
        await imprimirComprovantePagamento(comanda, !!(configModuloSel.monitorDesktop || configModuloSel.monitorWeb));
    }
}, [configModuloSel, imprimirComprovantePagamento]);

const tentarImprimirComprovantesNovamente = async () => {
    setReimprimindoComprovantes(true);
    try {
        for (const { comanda, peloMonitor } of [...comprovantesPendentesRef.current.values()]) {
            await imprimirComprovantePagamento(comanda, peloMonitor);
        }
    } finally {
        setReimprimindoComprovantes(false);
    }
};

    return (
        <PrinterContext.Provider value={{ printNFCe, printNFCePDFById, printNFSePDFById, visualizarNFCe, printRecibo, printReciboPDF, printReciboPedido, printPedidoPDFById, imprimirPdfBlob, printComprovantePagComandaPDF, imprimirComprovantesQuitados, imprimirComprovantePagamento }}>
            {children}
            {quantidadeComprovantesPendentes > 0 && (
                <button type="button" disabled={reimprimindoComprovantes} onClick={tentarImprimirComprovantesNovamente}
                    style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1050, padding: 12 }}>
                    Tentar imprimir comprovantes novamente ({quantidadeComprovantesPendentes})
                </button>
            )}
        </PrinterContext.Provider>
    );
};

// Hook para utilizar o contexto de impressão
export const usePrinter = () => {
    const context = useContext(PrinterContext);
    if (!context) {
        throw new Error("usePrinter must be used within a PrinterProvider");
    }
    return context;
};
